import React from "react";
import Container from "../../components/container";
import HeroSmall from "../../components/hero-small-project";

const Coinis = props => (
  <main>
    <HeroSmall 
      name="Adwe.com"
      title="RTB Platform" 
      desc="Managing a self-coded Real-Time-Bidding Platform which operates with all ad formats for both mobile and desktop users, handling over 5B daily requests globally. " 
    /> 

    <Container customClassName="project-padding">
      <img src="/static/adwe-logo.png" className="project-logo" alt="adwe.com" />
      <p>Established in 2015, Adwe is an OpenRTB platform powered and driven by strong engines that accumulate and recommend the best content for website visitors. By combining such tech with the right amount of passionate digital advertising mavens and prolific engineers, Adwe managed to position itself among the best content recommendation platforms worldwide.</p>
      <p>Though they are bathing now in success, the background story was as thorny as a plethora of rose bushes. The urge to develop such platform came after its founders met and discussed the Internet’s need for a properly vetted system which delivers content based on real-time preferences - excluding all unwanted articles while prolonging the visitors on line journey with even more interesting content.</p>
      <p>Though mainly focused on engaging users on websites and apps, Adwe also strained to create the right chemistry between advertisers and top-tier publishers while providing both parties with access to state-of-the-art predictive technology that will skyrocket their ROI. They make sure that ads appear on the right places, while taking utmost care about user-experience, fraud detection as well as their elimination.</p>
      <p>Thousands of customers of all sizes speak volumes about Adwe’s efforts in the advertising industry, and every single one of them would either recommend it for advertising or monetization purposes. Most certainly one of the biggest brand catalysts among seach and social for campaign advocacy.</p>

      <p>More at: <a href="https://adwe.com" target="_blank">adwe.com</a></p>
    </Container>
  </main>
);

export default Coinis;



// WEBPACK FOOTER //
// ./src/pages/project/adwe.js